import { daysToMilliseconds } from '@OC-common/utils/datetime.utils';
import { INextInspectionDateGroup } from './INextInspectionDateGroup';

export class NextInspectionDateGroup implements INextInspectionDateGroup {
  text: string;
  lowLimit?: number;
  highLimit?: number;

  constructor(text: string, lowLimit: number, highLimit: number) {
    this.text = text;
    this.lowLimit = lowLimit ? daysToMilliseconds(lowLimit) : lowLimit;
    this.highLimit = highLimit ? daysToMilliseconds(highLimit) : highLimit;
  }

  public isInGroup(lastInspectionDate: Date, nextInspectionDate: Date): boolean {
    const inspectionDate = nextInspectionDate || lastInspectionDate;
    const timespan = inspectionDate.getTime() - Date.now();
    return (
      // higher than low limit
      (!this.lowLimit || timespan > this.lowLimit)
      // lower than high limit
      && (!this.highLimit || timespan <= this.highLimit)
    )
  }
}
